"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const query_string_1 = require("query-string");
const config_1 = __importDefault(require("../config"));
class General {
    static async CheckStatus(org) {
        try {
            const options = {
                withCredentials: true
            };
            let url = `${config_1.default.ONLINE_API_URL}/api/status`;
            if (org) {
                url += `?organization=${org}`;
            }
            let response = await axios_1.default.get(url, options);
            return response.data;
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
    static async Ping(username, organization, has_unsynced_orders = 0, additional_data, orders) {
        try {
            const options = {
                withCredentials: true
            };
            const data = {
                username,
                organization,
                has_unsynced_orders
            };
            if (additional_data) {
                data.data = additional_data;
            }
            if (orders) {
                data.orders = orders;
            }
            let response = await axios_1.default.post(`${config_1.default.ONLINE_API_URL}/api/admin/v2/ping-orders`, data, options);
            return response.data;
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
    static async GetReports(org, date, username) {
        try {
            const options = {
                withCredentials: true
            };
            let url = `${config_1.default.ONLINE_API_URL}/api/v1/internal/get-location-report`;
            const params = {
                organization: org,
                date: `${date} 00:00:00`
            };
            if (username) {
                params.username = username;
            }
            url += `?${(0, query_string_1.stringify)(params)}`;
            let response = await axios_1.default.get(url, options);
            return response.data;
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
}
exports.default = General;
